module.exports = __webpack_public_path__ + "static/cracked tooth-e7eb9bb030583bd518992138e4449b7e.gif";